import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IServerResponse } from '../types/server-response';

@Injectable({
  providedIn: 'root'
})
export class TablaMaestraService {

  private url = `${environment.baseUrlAPI}/api/maestro`;

  constructor(private http: HttpClient) { }

  getParametros = (tabla: string) => {
    const params = { tabla };
    return this.http.get<IServerResponse<any[]>>(`${this.url}/getparametros`, { params });
  }
}
